import { useLazyChmlnSignatureQuery } from 'api/admin-api/admin-api';
import {
  useGetAdminQuery,
  useLazyGetClientConfigQuery,
  useLazyListMerchantsQuery,
  useLazyListStoresQuery,
} from 'api/client-domain/client-domain';
import { useLazyLogoutQuery } from 'api/oauth/oauth';
import { useLazyListProgramsQuery } from 'api/offers-domain/offers-domain';
import { useSuspendQueries } from 'hooks/rtkq.hooks';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAdminId } from 'redux/user/user.selectors';

export const usePreloadComponent = () => {
  const adminId = useSelector(selectAdminId);
  const getAdminResponse = useSuspendQueries(useGetAdminQuery(adminId), {
    throwErrors: false,
  });
  const [triggerMerchants, merchantsQueryResponse] =
    useLazyListMerchantsQuery();
  const [triggerClientConfig, clientConfigQueryResponse] =
    useLazyGetClientConfigQuery();
  const [triggerLogout] = useLazyLogoutQuery();
  const [triggerPrograms, programsQueryResponse] = useLazyListProgramsQuery();
  const [triggerChmlnSignature] = useLazyChmlnSignatureQuery();
  const [triggerStores] = useLazyListStoresQuery();

  const { isSuccess, isError, error } = useSuspendQueries(
    {
      ...getAdminResponse,
      endpointName: getAdminResponse?.endpointNames?.[0],
      originalArgs: getAdminResponse?.originalArgs?.[0],
    },
    merchantsQueryResponse,
    clientConfigQueryResponse,
    programsQueryResponse,
    { throwErrors: false },
  );

  useEffect(() => {
    if (!!isError) triggerLogout();
  }, [isError, triggerLogout]);

  useEffect(() => {
    if (getAdminResponse.isSuccess) {
      triggerMerchants();
      triggerClientConfig(null);
      triggerChmlnSignature();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getAdminResponse.isSuccess,
    triggerChmlnSignature,
    triggerClientConfig,
    triggerMerchants,
  ]);

  useEffect(() => {
    if (merchantsQueryResponse.isSuccess) {
      triggerPrograms();
      triggerStores({ count: 1000, page: 0 });
    }
  }, [merchantsQueryResponse.isSuccess, triggerPrograms, triggerStores]);

  return { isSuccess, isError, error };
};
